<template>
  <div>
    <div class="form-section">
      <h3 class="section-title">차상위 계층 여부</h3>
      <ul class="check-list">
        <li>
          <div class="check-wrap">
            <input type="checkbox" class="sr-only" :disabled="isDisabled" v-model="appInfo.SECLEV" true-value="Y" false-value="N" id="SECLEV" title="SECLEV 선택" />
            <label for="SECLEV"><span>차상위 계층</span></label>
          </div>
        </li>
      </ul>
    </div>
    <div class="form-section mt-32">
      <h3 class="section-title">재참여 여부</h3>
      <ul class="check-list">
        <li>
          <div class="radio-group">
            <label class="radio-item" for="NEWANDRE_N">
              <input type="radio" id="NEWANDRE_N" class="sr-only" name="NEWANDRE" value="N" v-model="appInfo.NEWANDRE" :disabled="isDisabled" title="NEWANDRE_N 선택">
              <span class="custom-radio"></span>
              신규참여
            </label>
            <label class="radio-item" for="NEWANDRE_Y">
              <input type="radio" id="NEWANDRE_Y" class="sr-only" name="NEWANDRE" value="Y" v-model="appInfo.NEWANDRE" :disabled="isDisabled" title="NEWANDRE_Y 선택">
              <span class="custom-radio"></span>
              재참여
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JbSpecificFields',
  props: {
    appInfo: {
      type: Object,
      default: () => ({})
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// JbSpecificFields.vue?0817d1b9